export const EMPLOYEE_NODE_WIDTH = 252;
export const EMPLOYEE_NODE_HEIGHT = 138;
